export default __webpack_public_path__ + "static/media/NET_Logo.b4a1f214.svg";